// tslint:disable:max-classes-per-file

import { Action } from '@ngrx/store';

import { Shift } from '../../models/shift';

export const EDIT_SHIFT = '[Shift] edit shift';
export const EDIT_SHIFT_SUCCESS = '[Shift] edit shift success';
export const EDIT_SHIFT_FAIL = '[Shift] edit shift fail';

export class EditShift implements Action {
  public readonly type = EDIT_SHIFT;

  constructor(public payload: { shiftToEdit: Shift; shifts: Array<Shift> }) {}
}

export class EditShiftSuccess implements Action {
  public readonly type = EDIT_SHIFT_SUCCESS;

  constructor(public payload: Array<Shift>) {}
}

export class EditShiftFail implements Action {
  public readonly type = EDIT_SHIFT_FAIL;

  constructor(public payload: any = null) {}
}

export type ShiftSettingsEditActions =
  | EditShift
  | EditShiftSuccess
  | EditShiftFail;
